import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type AuthenticationFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const AuthenticationFilled = forwardRef<SVGSVGElement, AuthenticationFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-5.250061 -5.249992) scale(0.71875)">
        <path d="M39.2518 22.3537L35.9567 19.0611V14.5338C35.9567 13.0932 34.927 12.0643 33.4854 12.0643H29.9844C29.3666 12.0643 28.7487 11.8585 28.3369 11.2412L25.8656 8.7717C24.8359 7.74277 23.3943 7.74277 22.3645 8.7717L19.8932 11.2412C19.2754 11.6527 18.6576 12.0643 18.0398 12.0643H14.5388C13.0972 12.0643 12.0674 13.0932 12.0674 14.5338V18.0322C12.0674 18.6495 11.8615 19.2669 11.2437 19.6785L8.77237 22.3537C7.74266 23.3826 7.74266 24.8232 8.77237 25.8521L11.2437 28.3215C11.6556 28.7331 12.0674 29.3505 12.0674 29.9678V33.4662C12.0674 34.9068 13.0972 35.9357 14.5388 35.9357H18.0398C18.6576 35.9357 19.2754 36.1415 19.6873 36.7588L22.1586 39.2283C23.1883 40.2572 24.6299 40.2572 25.6596 39.2283L28.1309 36.7588C28.5428 36.3473 29.1606 35.9357 29.7785 35.9357H33.2795C34.7211 35.9357 35.7508 34.9068 35.7508 33.4662V29.9678C35.7508 29.3505 35.9567 28.7331 36.5745 28.3215L39.0458 25.8521C40.2815 24.8232 40.2815 23.1769 39.2518 22.3537ZM24.0121 30.5852L17.8338 17.4148H20.923L24.0121 24.2058L27.1012 17.4148H30.1903L24.0121 30.5852Z" />
      </g>
    </svg>
  ),
);

AuthenticationFilled.displayName = 'AuthenticationFilled';

export default AuthenticationFilled;
